var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6938 13.0207C26.204 12.5309 25.3877 12.5309 24.8979 13.0207L12.4081 25.5105C11.9183 26.0003 11.9183 26.8166 12.4081 27.3064L20.1224 35.0207C20.6122 35.5105 21.4285 35.5105 21.9183 35.0207L34.4081 22.5309C34.8979 22.0411 34.8979 21.2248 34.4081 20.735L26.6938 13.0207ZM21.0612 33.5513L13.9183 26.4085L25.7959 14.5309L32.9387 21.6738L21.0612 33.5513Z",
    fill: "#FF9545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.7347 0 0 10.7347 0 24C0 37.2245 10.7347 48 24 48C37.2653 48 48 37.2653 48 24C48 10.7347 37.2653 0 24 0ZM39.4694 22.2449L21.6326 40.0816C20.6531 41.0612 19.0612 41.0612 18.0816 40.0816L14.5306 36.5306C15.5102 35.551 15.5102 33.9592 14.5306 32.9796C13.551 32 11.9592 32 10.9796 32.9796L7.42857 29.4286C6.44898 28.449 6.44898 26.8571 7.42857 25.8776L25.2653 8.04082C26.2449 7.06123 27.8367 7.06123 28.8163 8.04082L32.3673 11.5918C31.3878 12.5714 31.3878 14.1633 32.3673 15.1429C33.3469 16.1224 34.9388 16.1224 35.9184 15.1429L39.4694 18.6531C40.449 19.6735 40.449 21.2653 39.4694 22.2449Z",
    fill: "#FF9545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoticket);
export default __webpack_public_path__ + "static/media/goticket.5c2e9d0d.svg";
export { ForwardRef as ReactComponent };